import { AfterViewInit, Component, HostBinding } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { SystemService } from './core/system/system.service';
import { InitializationStateEnum } from './core/system/enum/initialization-state.enum';
import { debounceTime, from } from 'rxjs';
import { UserService } from './module/iam/user-settings/user.service';
import { filter } from 'rxjs/operators';
import { HardwareFingerprintService } from './shared/service/fingerprint.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
    @HostBinding('class') classes = 'ui-themed-container ui-application-container';
    protected actualTheme = 'ui-dark-green-theme';
    protected withNavBar = false;
    protected initialized = false;

    public body: HTMLElement = document.querySelector('body') as HTMLElement;
    title = '';

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected systemService: SystemService,
        protected fingerprintService: HardwareFingerprintService,
        protected userService: UserService
    ) {
        from(this.systemService.initializeDeviceId()).subscribe(() => {
            this.systemService.initialize(route, router);
        })
    }

    public ngAfterViewInit() {
        const token = this.systemService.getLocalStorage('token');
        if (token) {
            this.userService.getUserInformation(this.systemService.getLocalStorage('userId') as string).subscribe(
                (user) => {
                    this.systemService.setUser(user);
                }, (error) => {
                    console.error(error);
                    this.systemService.setUser(undefined);
                }
            );
        } else if (!location.pathname.startsWith('/health/analysis/release') && !location.pathname.includes('sign/in')) {

            const currentQueryParams: Record<string, string> = {};
            new URLSearchParams(window.location.search).forEach((value, key) => {
                currentQueryParams[key] = value;
            });

            this.router.navigate(['iam/sign/in'], {
                queryParams: currentQueryParams
            });
        }

        this.watchSystem();
    }

    protected removeFullLoading(): void {
        const loadingElement = document.getElementById('loading-panel');
        if (loadingElement) {
            loadingElement.remove();
        }
    }
    protected watchSystem(): void {
        this.systemService.watchInitialization().pipe(debounceTime(2000)).subscribe((initialized) => {
            if (initialized === InitializationStateEnum.INITIALIZED) {
                this.initialized = true;
                this.removeFullLoading();
                this.validateRoute();
            }
        });
        this.systemService.watchTheme().subscribe((theme) => {
            this.body.classList.remove(this.actualTheme);
            this.body.classList.add(theme);
            this.actualTheme = theme;
        });
        this.router.events.pipe(filter(() => this.initialized)).subscribe(() => {
            this.validateRoute();
        });
    }
    protected validateRoute(): void {
        const locationUrl = location.pathname;
        if (locationUrl.includes('/co-doctor') || locationUrl.includes('sign/in')) {
            this.withNavBar = false;
        } else {
            this.withNavBar = true;
        }
    }
}
